import { Paper, Stack, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { UserLayout, UserProfile } from '../../../UserProfile'

export const GrowerEdit = () => {
  const { t } = useTranslation('impact/pages/GrowerEdit')
  const { enqueueSnackbar } = useSnackbar()
  return (
    <UserLayout>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
        <Stack spacing={2}>
          <Typography variant="h6">{t('editProfile')}</Typography>
          <UserProfile
            userFormProps={{
              showStatusField: false,
              showPersonaField: false,
              onComplete: () => enqueueSnackbar(t('saveSuccessful'), { variant: 'success' }),
              onError: () => enqueueSnackbar(t('somethingWentWrong'), { variant: 'error' }),
            }}
          />
        </Stack>
      </Paper>
    </UserLayout>
  )
}
